import React from 'react';
import { cn, formatNumber } from '@/app/lib/utils';
import Pill, { PillColor } from '@/app/components/ui/Pill';

export interface PlanBalanceCardProps {
  planName: string;
  credits: number;
  creditsLabel: string;
  statusLabel?: string;
  statusColor?: PillColor;
  action?: React.ReactNode;
  className?: string;
}

export default function PlanBalanceCard({
  planName,
  credits,
  creditsLabel,
  statusLabel,
  statusColor = 'success',
  action,
  className,
}: PlanBalanceCardProps) {
  return (
    <div
      className={cn(
        'flex flex-col gap-2 rounded-lg border border-primary/40 bg-primary/10 px-4 py-2',
        className
      )}
    >
      <div className="flex items-center gap-2">
        <span className="min-w-0 truncate text-xs font-medium text-muted-foreground">
          {planName}
        </span>
        {statusLabel ? (
          <Pill color={statusColor} hasDot>
            <span className="size-2 rounded-full bg-current" />
            {statusLabel}
          </Pill>
        ) : null}
      </div>

      <div className="flex items-center justify-between gap-3">
        <p className="flex min-w-0 items-baseline gap-1.5 text-foreground">
          <span className="text-lg font-medium leading-none">{formatNumber(credits)}</span>
          <span className="truncate text-sm">{creditsLabel}</span>
        </p>
        {action}
      </div>
    </div>
  );
}
